import React from 'react';
import TabBase from './TabBase';

class Tab extends React.Component {
  getStyles = type => {
    switch (type) {
      case 'primary':
        return {};
      case 'secondary':
        return {
          tabsRoot: {
            margin: '1rem 0 2rem 0',
            borderBottom: 'none',
            backgroundColor: '#FFFFFF',
          },
          tabsIndicator: {
            marginRight: '0.5rem',
            backgroundColor: '#155CB4',
            borderBottom: '1px solid #155CB4',
          },
          tabRoot: {
            color: 'black',
            textTransform: 'initial',
            minWidth: 72,
            marginRight: '0.5rem',
            padding: '0 0 0 2rem',
            backgroundColor: '#FAFAFC',
            border: '0.5px solid #C4C4CD',
            '&:hover': {
              color: 'black',
              opacity: 1,
            },
            '&$tabSelected': {
              color: 'black',
              backgroundColor: '#FFFFFF',
              fontWeight: 'bold',
            },
            '&:focus': {
              color: 'black',
            },
          },
          tabSelected: {},
          label: {
            fontSize: '12px',
          },
          badge: {
            '& span': {
              top: '-14%',
              width: '26px',
              right: '112%',
              height: '18px',
              borderRadius: '37%',
            },
          },
          allCases: {
            backgroundColor: '#1777CF',
          },
          openCases: {
            backgroundColor: '#2DB757',
          },
          closedCases: {
            backgroundColor: '#FF4136',
          },
          allCasesIndicator: {
            marginRight: '0.5rem',
            backgroundColor: '#155CB4',
            borderBottom: '1px solid #155CB4',
          },
          openCasesIndicator: {
            marginRight: '0.5rem',
            backgroundColor: '#2DB757',
            borderBottom: '1px solid #2DB757',
          },
          closedCasesIndicator: {
            marginRight: '0.5rem',
            backgroundColor: '#FF4136',
            borderBottom: '1px solid #FF4136',
          },
        };
      default:
        return {};
    }
  };

  render() {
    let { styleType, children, handleChangeStatus, ...otherProps } = this.props;
    let styles = this.getStyles(styleType);
    return <TabBase styles={styles} styleType={styleType} children={children} handleChangeStatus={handleChangeStatus} {...otherProps} />;
  }
}

export default Tab;



// WEBPACK FOOTER //
// ./src/ui/library/Tab/Tab.js